import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    HostListener,
    Output,
    QueryList,
    ViewChild,
    input,
    output,
    inject,
} from '@angular/core';
import { TemplateObservable } from '@bazis/shared/classes/template-observable';
import { tap } from 'rxjs';
import { SwipeDirective } from '@bazis/shared/directives/swipe.directive';
import { ButtonModule } from '@bazis/shared/components/web/button/button.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { CommonModule } from '@angular/common';
import { ColorDirective } from '@bazis/shared/directives/color.directive';
import { SizeRange } from '@bazis/shared/models/base.types';

@Component({
    selector: 'bazis-slider',
    templateUrl: './slider.component.html',
    imports: [SwipeDirective, ButtonModule, IconModule, ColorDirective, CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SliderComponent implements AfterViewInit {
    public cdr = inject(ChangeDetectorRef);

    // корректировка для сдвига, если по макетам часть следующего слайда
    // находится в области видимости ширины контейнера
    readonly correctX = input<number>(0);

    // расстояние между слайдами
    readonly gapSlide = input<number>(0);

    readonly hasIndicator = input<boolean>(false);

    readonly iconPrev = input<string>('arrow-left');

    readonly iconNext = input<string>('arrow-right');

    readonly typeButton = input<'solid' | 'clear' | 'outline'>('outline');

    readonly sizeButton = input<SizeRange>(SizeRange.regular);

    resized = output();

    @ViewChild('sliderContainer', { static: true }) set contentWrapEl(el: ElementRef) {
        if (!el) return;

        this.wrapper = el.nativeElement;
    }

    @ContentChildren('slide') list: QueryList<ElementRef>;

    @HostListener('window:resize') onResize() {
        if (this.list.length) {
            this.shift = 0;
            this.isEndSlider = false;
            this.init(this.list.toArray());
        }
    }

    wrapper;

    currentSwipe = 0;

    isEndSlider = false;

    allSlidesWidth: number = 0;

    containerWidth: number;

    shift: number = 0;

    list$;

    swipesCounter = new TemplateObservable(0);

    ngAfterViewInit(): void {
        if (this.list.length) {
            // чтобы верно отсчитался размер контейнера
            setTimeout(() => {
                this.init(this.list.toArray());
            }, 0);
        }

        this.list$ = this.list.changes.pipe(tap((list) => this.init(list)));
    }

    init(list) {
        let listWidth = 0;
        list.forEach((slide) => {
            listWidth = listWidth + slide.nativeElement.clientWidth;
        });
        this.allSlidesWidth = listWidth + (list.length - 1) * this.gapSlide();

        this.containerWidth = this.wrapper.parentNode.clientWidth;

        if (this.containerWidth) {
            this.swipesCounter.set(
                Math.ceil(
                    (this.allSlidesWidth - this.correctX()) /
                        (this.containerWidth + this.gapSlide()),
                ),
            );
        }
        this.shiftCorrect(); // чтобы если надо, задисейблить листание далее

        this.cdr.detectChanges();
    }

    slideStart() {
        this.shift = this.shift + this.containerWidth - this.correctX() + this.gapSlide();
        if (this.currentSwipe !== 0) this.currentSwipe--;
        this.shiftCorrect();
    }

    slideEnd() {
        this.shift = this.shift - this.containerWidth + this.correctX() - this.gapSlide();
        if (this.currentSwipe < this.swipesCounter._ - 1) ++this.currentSwipe;
        this.shiftCorrect();
    }

    shiftCorrect() {
        if (this.shift <= this.containerWidth - this.allSlidesWidth - this.correctX()) {
            this.shift = this.containerWidth - this.allSlidesWidth - this.correctX();
            this.isEndSlider = true;
        } else {
            this.isEndSlider = false;
        }
        if (this.shift > 0) this.shift = 0;
    }
}
